import React from 'react'
import { Helmet } from 'react-helmet'

import { PathProps, getPaths } from '../screens/Organization/constants'
import { IntlShape, useIntl } from 'react-intl'
import { useIsSuperEnabledFromUrl } from '../utils'

function getHelmetMetadata(
  pathMetadata: PathProps,
  intl: IntlShape,
  superEnabled: boolean
) {
  const product = superEnabled ? 'Super' : 'Slite'
  const metaTitle = intl.formatMessage(pathMetadata.metaTitle, {
    product,
  })
  const metaDescription = intl.formatMessage(pathMetadata.metaDescription, {
    product,
  })
  const canonicalUrl = pathMetadata.canonicalUrl
  return {
    title: metaTitle,
    meta: [
      {
        name: 'description',
        content: metaDescription,
      },
      {
        property: 'og:title',
        content: metaTitle,
      },
      {
        property: 'og:description',
        content: metaDescription,
      },
      {
        property: 'og:url',
        content: canonicalUrl,
      },
      {
        property: 'og:type',
        content: 'product',
      },
      {
        property: 'og:site_name',
        content: superEnabled ? 'Super' : 'Slite',
      },
      {
        property: 'og:image',
        content: 'https://assets.slite.com/illustrations/meta-image.jpg',
      },
    ],
    link: [{ rel: 'canonical', href: canonicalUrl }],
  }
}

export const usePathMetadata = (path: keyof ReturnType<typeof getPaths>) => {
  const intl = useIntl()
  const superEnabled = useIsSuperEnabledFromUrl()
  const pathMetadata = getPaths(superEnabled)[path]
  const metadata = getHelmetMetadata(pathMetadata, intl, superEnabled)
  return function PreparedHelmet() {
    return <Helmet {...metadata} />
  }
}
